<template>
<span class="np-checkbox"
	:class="{
		'np-checkbox_disable':disable,
		'np-checkbox_cir':shape==='cir',
		'np-checkbox_switch':shape==='switch',
		'np-checkbox_org':color==='org'
	}"
>
	<input  :value="val" :disabled="disable" :checked="checked" :type="radio?'radio':'checkbox'" @change="change" @click="handleClick">
	<i class="np-checkbox-style"></i>
</span>
</template>
<script>
/* 
	@与原生checkbox差不多的用法 v-model 双向绑定 :val 绑定数据  
		v-model绑定为数组时，则自动添加到数组中，如绑定不为数组，则返回true和false
	@监听change事件 返回原始事件对象
	@单选绑定 
	color:  @样式选择 "org"，橙色  "base"，主色  
	shape:	@形状 "cir"，圆 "base"，直角
	disable:	@状态，true 不可选  2，选中 3，可选
	radio:	@选取形式 true，单选框 false，多选框
	
	val:参考原始radio或者checkbox的value绑定	
*/
//import _ from "underscore"
export default {
	props:["color","radio","disable","shape","value","val"],
	data: function(){
		return {
			checked:false
		}
	},
	mounted: function(){
		this.checked = this.setChecked();
	},
	methods:{
		handleClick(e) {
			this.$emit("click",e);
		},
		change: function(e){
			this.$emit("change",e);
			this.checked = e.target.checked;
			var checked = this.checked,val = this.val;	
				//原始事件
				this.$emit("change",e);
			if(!this.radio){
				if(!(this.value instanceof Array)){
					return this.$emit("input",checked);
				}
				//多选
				if(checked){
					this.value.push(val);
					this.uniq(this.value);
				}else{
					this.delval(val);
				}
			}else{
				//单选
				this.$emit("input",val);
			}
		},
		uniq:function(arr){
			//数组去重
			for(var i=0;i<arr.length;i++){
				for(var j=i+1;j<arr.length;j++){
					if(arr[i] === arr[j]){
						arr.splice(j,1);
						j--
					}
				}
			}
		},
		delval: function(val){
			//删除数组中对应值
			for(var i = 0,len = this.value.length;i<len;i++){
				if(val === this.value[i]){
					this.value.splice(i,1);	
					break;
				}				
			}
		},
		setChecked: function(){
			if(!this.radio){
				//多选
				if(this.value instanceof Array){
					for(var i = 0 ,len = this.value.length;i<len;i++){
						if(this.val === this.value[i]){
							return true;
						}
					}
				}else{
					//绑定非数组
					return !!this.value;
				}
			}else{
				//单选
				return this.val === this.value;
			}
		}
	},
	watch:{
		value: function(){	
			this.checked = this.setChecked();
		}
	}
}
</script>
<style lang="scss">
$checkbox-width: 16px;
$checkbox-border-disable: $color-border;
$checkbox-border-active: $color-border-main;
$checkbox-active-border: $color-white;
$checkbox-bg-active: $color-main;
$checkbox-after-width: $checkbox-width * 0.55;
$checkbox-after-height: $checkbox-width * 0.2;
$checkbox-orgbg: $color-org;
$checkbox-orgbrd: $color-org;
$checkbox-border: $color-border-input;
$checkbox-switch-after: $color-white;
$checkbox-switch-width:  $checkbox-width + 4;
.np-checkbox {
	display: inline-block;
	width: $checkbox-width;
	height: $checkbox-width;
	position: relative;
	input {
		position: absolute;
		left: 0;
		height: 100%;
		top: 0;
		width: 100%;
		z-index: 1;
		cursor: pointer;
		opacity: 0;
	}
	&_disable {
		input {
			cursor: no-drop;
		}
		.np-checkbox-style {
			border-color: $checkbox-border-disable;
		}
	}
	& input:checked + &-style {
		border-color: $checkbox-border-active;
		background-color: $checkbox-bg-active;
		&::after {
			content: "";
		}
	}
	&-style,&-style::after {
		@include  trans-animate();
	}
	//np-checkbox-style
	&-style {
		box-sizing: border-box;
		display: block;
		position: relative;
		height: 100%;
		border: 1px solid $checkbox-border;
		border-radius: 2px;
		&::after {
			top: $checkbox-after-height ;
			left: calc($checkbox-after-height / 2);
			position: absolute;
			display: inline-block;
			width: $checkbox-after-width;
			height: $checkbox-after-height;
			border-left: 2px solid $checkbox-active-border;
			border-bottom: 2px solid $checkbox-active-border;
			@include  transform-rotate(-45deg);
			transform-origin: center center;
		}
	}
	//np-checkbox np-checkbox_cir np-checkbox_org
	&_cir {
		.np-checkbox-style {
			border-radius: 50%;
		}
	}
	&_org {
		& input:checked + .np-checkbox-style {
			background-color: $checkbox-orgbg;
			border-color: $checkbox-orgbrd;
		}
	}
	//np-checkbox_switch
	&_switch {
		&.np-checkbox {
			width: $checkbox-switch-width * 2;
			height: $checkbox-switch-width;
			& input:checked + .np-checkbox-style {
				&::after {
					left: $checkbox-switch-width;
				}
			}
		}
		.np-checkbox-style {			
			border-radius: $checkbox-switch-width;
			background-color: $checkbox-border;
			border-color: $checkbox-border;
			&::after {
				content: "";
				border: 0;
				top: 1px;
				width: $checkbox-switch-width - 4;
				height: $checkbox-switch-width - 4;
				background-color: $checkbox-switch-after;
				border-radius: 50%;
			}
		}
	}
}
</style>
